<template>
    <b-container>
          <h1 class="title">Edit Src: {{ user.user_name }}</h1>
        
          <cluster-teams></cluster-teams>
    </b-container>
</template>
<script>
import UserService from "@/services/UsersService";
import router from "@/router";
import ClusterTeams from '../components/ClusterTeams';

export default {
    name:"EditSrc",
    components:{ClusterTeams},
    data(){
        return{
            user:[],
        }
    },
    methods:{
        async getUser(){
            const id = router.currentRoute.params.id;
            var tmp = await UserService.getUser(id);
            this.user =  tmp.data.results[0];
        }
    },
    created(){
        this.getUser();
    }
    
}
</script>